import * as React from 'react';

import classNames from 'classnames';

import { IButtonProps } from './types';

import * as s from './Button.scss';

/**
 * Button Component
 * @return React.Node
 */

export const Button = (props: IButtonProps) =>
	<button
		disabled={props.isDisable}
		onClick={props.onClick}
		className={classNames(props.className, s.block)}
		type={props.type}>
		{props.children}
	</button>;
